import io from 'socket.io-client';

export const socket = io.connect(process.env.REACT_APP_BASE_WEB_SOCKET_URL, {
	auth: { token: localStorage.getItem('auth-token') },
	query: { token: localStorage.getItem('auth-token') },
	transports: ['websocket'],
	reconnection: false,
});
